import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'
import { PERFORMANCE_SECTION_HEIGHT } from '../../utils'

export const ScoreWrapper = styled(Box)<{ isExpanded: boolean }>`
  background: ${theme.colors.surfaceContainerBackground};
  border-radius: ${theme.attributes.borderRadius.quaternary};
  padding: ${theme.spacing.medium}px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  height: ${PERFORMANCE_SECTION_HEIGHT}px;
  transition: all 0.3s ease-in-out;

  .title-wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .left-section {
      display: flex;
      flex-flow: column wrap;
      gap: ${theme.spacing.xSmall}px;

      .title {
        display: flex;
        align-items: center;
        gap: ${theme.spacing.xSmall}px;
        white-space: nowrap;

        .chart-title {
          color: ${theme.colors.menuItemText};
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.xLarge};
          font-weight: ${theme.typography.fontWeight.bold};
          line-height: 24px;
          letter-spacing: 0.1px;
        }
      }

      .chart-title-update {
        color: ${theme.colors.cardDateText};
        /* label stays cardDateText (#5c5865); date value below → foreground */
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.medium};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: 16px;
        letter-spacing: 0.5px;
        white-space: nowrap;

        span {
          color: ${theme.colors.menuItemText};

          html[data-theme='light'] & {
            font-weight: ${theme.typography.fontWeight.extraThick};
          }
        }
      }
    }
  }

  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`
